var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.GetIEVersion() > 0)?_c('div',{staticClass:"unsupported-browser"},[_vm._v(" We're sorry, but this browser is not supported. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }